import { toast } from "react-toastify";
import { VideoAPI } from "../constants/apiRoutes";
import { videoActions } from "../reducers/video";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewVideo = (data, navigate) => {
  return async (dispatch) => {
    dispatch(videoActions.actionStart());
    try {
      await apiService.postMultipart(VideoAPI.create(), data);
      dispatch(videoActions.actionSuccess("create"));
    } catch (err) {
      dispatch(videoActions.clearError());
      handleError(err);
    }
  };
};

export const updateVideo = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(videoActions.actionStart());
    return apiService
      .putMultipart(VideoAPI.update(id), data)
      .then((response) => {
        dispatch(videoActions.actionSuccess("update"));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deleteVideo = (id) => {
  return (dispatch) => {
    return apiService
      .delete(VideoAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali video", {
          theme: "colored",
        });

        dispatch(fetchVideoList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoList = () => {
  return (dispatch) => {
    return apiService
      .get(VideoAPI.list())
      .then((response) => {
        dispatch(videoActions.fetchVideoList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoFormList = () => {
  return (dispatch) => {
    return apiService
      .get(VideoAPI.form())
      .then((response) => {
        dispatch(videoActions.fetchVideoFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(VideoAPI.getById(id))
      .then((response) => {
        dispatch(videoActions.fetchVideoDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoAnalyticsPublic = (page, size, data) => {
  return (dispatch) => {
    dispatch(videoActions.actionStartPublic());
    return apiService
      .post(VideoAPI.analyticPublic(page, size), data)
      .then((response) => {
        // Ako backend vrati prazan niz → NE ŠALJI REDUCERU NIŠTA
        if (!response.data || response.data.length === 0) {
          dispatch(videoActions.clearError());
          return { empty: true }; // ← VAŽNO!
        }
        dispatch(videoActions.fetchVideoAnalyticsPublic(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchVideoAnalyticsProtected = (page, size, data) => {
  return (dispatch) => {
    dispatch(videoActions.actionStartProtected());
    return apiService
      .post(VideoAPI.analyticProtected(page, size), data)
      .then((response) => {
        // Ako backend vrati prazan niz → NE ŠALJI REDUCERU NIŠTA
        if (!response.data || response.data.length === 0) {
          dispatch(videoActions.clearError());
          return { empty: true }; // ← VAŽNO!
        }
        dispatch(videoActions.fetchVideoAnalyticsProtected(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
